export const INTERVAL_GRAPH_POINTS = {
  THIRTY_MINUTES: 30,
  TWO_HOURS: 120,
  TWELVE_HOURS: 720,
  ONE_DAY: 1440,
}
